import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HandleError, HttpErrorHandlerService } from '../__common/_http/http-error-handler.service';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { BookingService } from '../booking.service';
import { EventEmitterService } from '../__common/event-emitter.service';

const PROJECT_API_URL = 'api-dashboard';
const httpOptions = {

  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'my-auth-token'
  })
};

@Injectable({
  providedIn: 'root'
})
export class ApiConnectorService {

  private httpPrefix = 'https://';
  private webPageDomain = 'voyjaleas.com';
  // Error handling
  private handleError: HandleError;
  cache = {};
  loading = false;
  lastObjectInserted;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandlerService,private bookingService: BookingService,private eventEmmiter: EventEmitterService) { 
    this.handleError = httpErrorHandler.createHandleError('ApiEmailService');
  }

  getDomain(a){
    return 'voyjaleas.com';  
  }

  getApiAssigned(a){
    return 'api-dashboard';  
  }

  simpleQueryId( queryId: string,queryParam1: string,queryParam2: string,queryParam3: string,queryParam4: string,queryParam5: string): Observable<any> {
    let phpFileName = '';
    let apiURL  = this.httpPrefix + this.getDomain(queryId) + '/' + this.getApiAssigned(queryId) + '/get/dynamic/query/';
    let queryParam = '?queryId='+queryId;
    queryParam1 !== null? queryParam = queryParam + '&queryParam1=' + queryParam1 : queryParam = queryParam;
    queryParam2 !== null? queryParam = queryParam + '&queryParam2=' + queryParam2 : queryParam = queryParam;
    queryParam3 !== null? queryParam = queryParam + '&queryParam3=' + queryParam3 : queryParam = queryParam;
    queryParam4 !== null? queryParam = queryParam + '&queryParam4=' + queryParam4 : queryParam = queryParam;
    queryParam5 !== null? queryParam = queryParam + '&queryParam5=' + queryParam5 : queryParam = queryParam;

    phpFileName = 'myapi.php';
    apiURL = apiURL + phpFileName + queryParam;
    let force = false;

    force = true;

    // Proceed
    this.sendRequestToServer(apiURL,queryId,force);
    return this.cache[queryId];
  }

  sendRequestToServer(url,label,force){
    if (!this.cache[label] || force) {
      this.cache[label] = this.http.get(`${url}`).pipe(
          map(data => data),
          publishReplay(1), // this tells Rx to cache the latest emitted
          refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      );
    }
  }

  tryToValidate(code){
    this.loading = true;
    this.simpleQueryId('validateCode',code,null,null,null,null).subscribe(response => this.resultCodeValid(response));
  }

  resultCodeValid(res){
    this.loading = false;
    if(res && res.OK){
      this.eventEmmiter.onValidationAttempt(true);
      this.bookingService.unlock();
    }else{
      this.eventEmmiter.onValidationAttempt(false);
      this.bookingService.lock();
    }
  }

  isLoading(){
    return this.loading;
  }

  newDynamicApiRequest(httpMethod: string, table: string, NewElement: any): Observable<any> {

    let phpFileName = '';
    httpMethod = httpMethod.toLocaleLowerCase();

    NewElement? this.lastObjectInserted = NewElement : this.lastObjectInserted = null;

    let apiUrl  = this.httpPrefix + this.webPageDomain + '/' + PROJECT_API_URL + '/' + httpMethod + '/dynamic/';
    const queryParam = '?table=' + table;
    switch (httpMethod) {
      case 'post':
        phpFileName = 'create.php' + queryParam;
        apiUrl = apiUrl + phpFileName;
        return this.http.post<any>(apiUrl, NewElement, httpOptions)
          .pipe(
            catchError(this.handleError('addingNewElement', {KO:{
              message: 'Error on create',
              code: '19'
            }}))
          );
      case 'put':
        phpFileName = 'update.php';
        apiUrl = apiUrl + phpFileName + queryParam;
        return this.http.put<any>(apiUrl, NewElement, httpOptions)
          .pipe(
            catchError(this.handleError('updatingElement', NewElement))
          );
      case 'delete':
        phpFileName = 'delete.php';
        debugger;
        apiUrl = apiUrl + phpFileName + queryParam + '&deleteItem='+NewElement.id;
        return this.http.delete(apiUrl, httpOptions )
          .pipe(
            catchError(this.handleError('removingElement', NewElement))
          );
      default: break;
    }
  }
  
}
